import 'css-chunksrc/client/scenes/listRemoval/listsList/list/task/nameEditionForm/styles.scss';export default {
  "nameEditionForm": "_nameEditionForm_1tj9o_1",
  "form": "_form_1tj9o_6",
  "name": "_name_1tj9o_1",
  "icon": "_icon_1tj9o_27",
  "input": "_input_1tj9o_31",
  "edition": "_edition_1tj9o_52"
};